var render = function () {
  var _vm$product, _vm$product$images, _vm$product2, _vm$product3, _vm$product4, _vm$product5, _vm$product6, _vm$product6$costPric, _vm$product6$costPric2, _vm$product7, _vm$product7$salePric, _vm$product7$salePric2, _vm$product$optionalP2, _vm$prevProduct, _vm$nextProduct, _vm$product8;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component",
    scopedSlots: _vm._u([{
      key: "fab",
      fn: function fn(_ref) {
        var _vm$product$optionalP;

        var showScroll = _ref.showScroll,
            scrollTo = _ref.scrollTo;
        return _vm.$vuetify.breakpoint.mobile && _vm.ready ? [_c('v-app-bar', {
          attrs: {
            "app": "",
            "bottom": "",
            "height": "auto",
            "color": "transparent",
            "elevation": "1"
          }
        }, [_c('v-responsive', {
          staticClass: "overflow-visible"
        }, [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: showScroll,
            expression: "showScroll"
          }],
          staticClass: "mt-n40px",
          attrs: {
            "fab": "",
            "absolute": "",
            "top": "",
            "right": "",
            "large": "",
            "tile": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return scrollTo(0, 0);
            }
          }
        }, [_c('div', {
          staticClass: "pa-12px"
        }, [_c('v-icon', {
          staticClass: "my-n4px",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("mdi-chevron-up")]), _c('div', {
          staticClass: "font-size-14 font-weight-medium mb-6px"
        }, [_vm._v("TOP")])], 1)]), _c('v-card', {
          attrs: {
            "elevation": "0"
          }
        }, [_c('v-divider'), _c('div', [_c('v-btn', {
          attrs: {
            "slot": "extension",
            "ripple": false,
            "block": "",
            "color": "grey lighten-4",
            "height": "28",
            "active-class": "no-active"
          },
          on: {
            "click": function click($event) {
              _vm.expand = !_vm.expand;
            }
          },
          slot: "extension"
        }, [_c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.expand,
            expression: "!expand"
          }],
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-chevron-up")]), _c('v-icon', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.expand,
            expression: "expand"
          }],
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-expand-transition', [_c('v-responsive', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.expand,
            expression: "expand"
          }],
          attrs: {
            "elevation": "0"
          }
        }, [_c('v-divider'), _c('div', {
          staticClass: "pa-12px py-md-14px"
        }, [(_vm$product$optionalP = _vm.product.optionalProducts) !== null && _vm$product$optionalP !== void 0 && _vm$product$optionalP.length ? [_c('optional-products', {
          attrs: {
            "product": _vm.product
          },
          model: {
            value: _vm.carts,
            callback: function callback($$v) {
              _vm.carts = $$v;
            },
            expression: "carts"
          }
        })] : _vm._e(), _vm.carts.length && !_vm.product.ebookProducts.length ? [_c('cart-list', {
          model: {
            value: _vm.carts,
            callback: function callback($$v) {
              _vm.carts = $$v;
            },
            expression: "carts"
          }
        })] : _vm._e(), _c('div', {
          staticClass: "mt-10px"
        }, [_c('v-row', {
          staticClass: "row--small font-size-14",
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "3",
            "md": "2"
          }
        }, [_vm._v(" 총 합계 ")]), _c('v-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "9",
            "md": "10"
          }
        }, [_c('div', {
          staticClass: "d-inline-flex align-center font-size-20"
        }, [_c('b', {
          staticClass: "primary--text"
        }, [_vm._v(_vm._s(parseInt(_vm.totalAmount).format()))]), _c('span', {
          staticClass: "font-size-14 ml-2px"
        }, [_vm._v("원")])])])], 1)], 1)], 2), _c('v-divider')], 1)], 1), _c('div', {
          staticClass: "pa-12px py-md-14px"
        }, [_c('v-row', {
          staticClass: "row--x-small"
        }, [_c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "disabled": !!_vm.product.ebookProducts.length,
            "icon": "",
            "tile": "",
            "outlined": "",
            "color": "grey",
            "width": "42",
            "height": "42"
          },
          on: {
            "click": _vm.gift
          }
        }, [_c('v-icon', {
          staticClass: "grey--text text--darken-3"
        }, [_vm._v("mdi-gift-outline")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "disabled": !!_vm.product.ebookProducts.length,
            "fab": "",
            "tile": "",
            "color": "secondary",
            "width": "42",
            "height": "42"
          },
          on: {
            "click": _vm.addToCart
          }
        }, [_c('v-icon', [_vm._v("mdi-cart-outline")])], 1)], 1), _c('v-col', [_vm.ebook ? [_c('v-btn', {
          attrs: {
            "x-large": "",
            "block": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.open(_vm.ebook);
            }
          }
        }, [_vm._v("열람하기")])] : [_c('v-btn', {
          attrs: {
            "x-large": "",
            "block": "",
            "color": "primary"
          },
          on: {
            "click": _vm.order
          }
        }, [_vm._v("구매하기")])]], 2)], 1)], 1)], 1)], 1)], 1)] : undefined;
      }
    }], null, true)
  }, [_vm.ready ? [_vm.ready && _vm.product ? _c('v-card', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onIntersect,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onIntersect, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "contents-area",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "elevation": "0"
    }
  }, [_c('v-responsive', {
    staticClass: "mx-auto",
    attrs: {
      "width": "100%",
      "max-width": "480"
    }
  }, [_c('v-carousel', {
    attrs: {
      "height": "auto",
      "hide-delimiters": "",
      "show-arrows-on-hover": "",
      "show-arrows": 1 < ((_vm$product = _vm.product) === null || _vm$product === void 0 ? void 0 : (_vm$product$images = _vm$product.images) === null || _vm$product$images === void 0 ? void 0 : _vm$product$images.length)
    }
  }, _vm._l(((_vm$product2 = _vm.product) === null || _vm$product2 === void 0 ? void 0 : _vm$product2.images) || [], function (image, index) {
    return _c('v-carousel-item', {
      key: index
    }, [_c('v-img', {
      attrs: {
        "src": image,
        "width": "100%",
        "max-width": "480",
        "contain": "",
        "aspect-ratio": 1 / 1
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "pl-md-10"
  }, [[_c('div', {
    staticClass: "tit-wrap mb-20px mb-md-30px"
  }, [_c('div', {
    staticClass: "tit tit--sm primary--text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.name)
    }
  })])])], _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [[_c('product-info-field', {
    staticClass: "font-weight-medium",
    attrs: {
      "label": "판매가"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [(_vm$product3 = _vm.product) !== null && _vm$product3 !== void 0 && _vm$product3.costPrice && ((_vm$product4 = _vm.product) === null || _vm$product4 === void 0 ? void 0 : _vm$product4.costPrice) != ((_vm$product5 = _vm.product) === null || _vm$product5 === void 0 ? void 0 : _vm$product5.salePrice) ? _c('span', {
    staticClass: "font-size-14 line-height-1 text-decoration-line-through grey--text mr-8px"
  }, [_vm._v(_vm._s((_vm$product6 = _vm.product) === null || _vm$product6 === void 0 ? void 0 : (_vm$product6$costPric = _vm$product6.costPrice) === null || _vm$product6$costPric === void 0 ? void 0 : (_vm$product6$costPric2 = _vm$product6$costPric.format) === null || _vm$product6$costPric2 === void 0 ? void 0 : _vm$product6$costPric2.call(_vm$product6$costPric)) + "원")]) : _vm._e()]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-20 line-height-1"
  }, [_c('b', [_vm._v(_vm._s((_vm$product7 = _vm.product) === null || _vm$product7 === void 0 ? void 0 : (_vm$product7$salePric = _vm$product7.salePrice) === null || _vm$product7$salePric === void 0 ? void 0 : (_vm$product7$salePric2 = _vm$product7$salePric.format) === null || _vm$product7$salePric2 === void 0 ? void 0 : _vm$product7$salePric2.call(_vm$product7$salePric)))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)]], 2), _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_vm.product.writer ? [_c('product-info-field', {
    attrs: {
      "label": "저자"
    }
  }, [_vm._v(_vm._s(_vm.product.writer))])] : _vm._e(), _vm.product.publisher ? [_c('product-info-field', {
    attrs: {
      "label": "출판사"
    }
  }, [_vm._v(_vm._s(_vm.product.publisher))])] : _vm._e(), !_vm.product.ebookProducts.length ? [_c('product-info-field', {
    attrs: {
      "label": "배송비"
    }
  }, [_vm.product.shippingCode === 'later' ? _c('span', [_c('b', [_vm._v("착불배송")])]) : _vm._e(), _vm.product.shippingCode === 'self' ? _c('span', [_c('b', [_vm._v(_vm._s(parseInt(_vm.product.shippingPrice).format()))]), _vm._v("원")]) : _vm._e(), _vm.product.shippingCode === 'free' ? _c('span', [_c('b', [_vm._v("배송비 무료")])]) : _vm._e(), _vm.product.shippingCode === 'order' ? _c('span', [_c('b', [_vm._v(_vm._s("".concat(_vm.setting.shippingPrice.lt.format(), "\uC6D0 (").concat(_vm.setting.saleAmount.format(), "\uC6D0 \uC774\uC0C1\uC740 \uBB34\uB8CC\uBC30\uC1A1)")))])]) : _vm._e()])] : _vm._e(), !_vm.product.ebookProducts.length ? [_c('product-info-field', {
    attrs: {
      "label": "배송일정"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', [_vm._v("* 당일 13시까지 주문건에 한하여, 당일 출고됩니다.")]), _c('div', [_vm._v(" 택배사 일정에 따라 2~3일 소요될 수 있습니다. (도서산간 제외)")])])])] : _vm._e(), _vm._l(_vm.product.info, function (item, index) {
    return _c('product-info-field', {
      key: index,
      attrs: {
        "label": item.name
      }
    }, [item ? _c('span', [_c('b', [_vm._v(_vm._s(item.value))])]) : _vm._e()]);
  }), _vm.product.ebookProducts.length ? [_c('product-info-field', {
    attrs: {
      "label": "지원기기"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', [_vm._v("iOS | Android | PC | Mac")]), _c('div', [_vm._v("iOS 13.4 버전부터 이용 가능")])])])] : _vm._e(), _vm.product.ebookProducts.length ? [_c('product-info-field', {
    attrs: {
      "label": "안내사항"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', [_vm._v("이 상품은 구매 후 웹에서 바로 이용 가능한 상품으로 배송되지 않습니다.")]), _c('div', [_vm._v("전자책 열람시 데이터가 소모되어 데이터 요금이 발생할 수 있습니다. Wifi를 이용해주세요.")]), _c('div', [_vm._v("구매한 eBook 상품은 마이페이지 > eBook 열람 에서 확인 가능합니다.")])])])] : _vm._e(), _vm.product.ebookProducts.length ? [_c('product-info-field', {
    attrs: {
      "label": "환불규정"
    }
  }, [_c('div', {
    staticClass: "grey--text text--darken-2"
  }, [_c('div', [_vm._v("최초 열람 이후 환불이 불가합니다. 미 열람시 7일 이내 100% 환불 가능하며 7일 이후 90%로 환불 가능합니다.")])])])] : _vm._e()], 2), !_vm.$vuetify.breakpoint.mobile && (_vm$product$optionalP2 = _vm.product.optionalProducts) !== null && _vm$product$optionalP2 !== void 0 && _vm$product$optionalP2.length ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('optional-products', {
    attrs: {
      "product": _vm.product
    },
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1)] : _vm._e(), !_vm.product.stock ? [_c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('product-info-field', {
    staticClass: "mt-4 font-weight-bold",
    attrs: {
      "label": "수량"
    }
  }, [_vm._v("품절")])], 1)] : _vm._e(), _c('v-divider'), !_vm.$vuetify.breakpoint.mobile && _vm.carts.length ? [!_vm.product.ebookProducts.length ? _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('cart-list', {
    model: {
      value: _vm.carts,
      callback: function callback($$v) {
        _vm.carts = $$v;
      },
      expression: "carts"
    }
  })], 1) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "2"
    }
  }, [_vm._v(" 총 합계 ")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "10"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-24"
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(parseInt(_vm.totalAmount).format()))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1), _c('v-divider', {
    staticClass: "border-2"
  }), _c('div', {
    staticClass: "py-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "outlined": "",
      "disabled": !!_vm.product.ebookProducts.length,
      "color": "grey"
    },
    on: {
      "click": _vm.gift
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px grey--text text--darken-3"
  }, [_vm._v("mdi-gift-outline")]), _c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("선물하기")])], 1)], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "disabled": !!_vm.product.ebookProducts.length,
      "color": "secondary"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-cart-outline")]), _vm._v("장바구니")], 1)], 1), _c('v-col', [_vm.ebook ? [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.open(_vm.ebook);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-shopping-outline")]), _vm._v("열람하기")], 1)] : [_c('v-btn', {
    attrs: {
      "block": "",
      "tile": "",
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.order
    }
  }, [_c('v-icon', {
    staticClass: "mr-10px"
  }, [_vm._v("mdi-shopping-outline")]), _vm._v("바로구매")], 1)]], 2)], 1)], 1)] : _vm._e()], 2)])], 1), _c('v-divider', {
    staticClass: "d-none d-lg-block"
  }), _c('div', {
    staticClass: "pt-10px pt-md-16px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey",
      "to": "/shop/".concat(_vm.path, "/").concat((_vm$prevProduct = _vm.prevProduct) === null || _vm$prevProduct === void 0 ? void 0 : _vm$prevProduct._id),
      "disabled": !_vm.prevProduct
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_c('v-icon', {
    staticClass: "mr-4px mr-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v("이전상품보기")], 1)])], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey",
      "to": "/shop/".concat(_vm.path, "/").concat((_vm$nextProduct = _vm.nextProduct) === null || _vm$nextProduct === void 0 ? void 0 : _vm$nextProduct._id),
      "disabled": !_vm.nextProduct
    }
  }, [_c('span', {
    staticClass: "d-flex align-center grey--text text--darken-3"
  }, [_vm._v("다음상품보기"), _c('v-icon', {
    staticClass: "ml-4px ml-md-10px",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)])], 1)], 1)], 1)], 1)]) : _vm._e(), _c('v-divider'), !_vm.isIntersecting ? _c('v-app-bar', {
    attrs: {
      "height": "54",
      "fixed": "",
      "color": "white",
      "elevation": "2"
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: _vm.intersectingIndex,
      callback: function callback($$v) {
        _vm.intersectingIndex = $$v;
      },
      expression: "intersectingIndex"
    }
  }, [_c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-content"
    }
  }, [_vm._v("상품정보")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-review"
    }
  }, [_vm._v("기대평/리뷰")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-inquiry"
    }
  }, [_vm._v("상품문의")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-delivery"
    }
  }, [_vm._v("교환/환불/배송")])], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "overflow-hidden"
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": "",
      "grow": ""
    },
    model: {
      value: _vm.intersectingIndex,
      callback: function callback($$v) {
        _vm.intersectingIndex = $$v;
      },
      expression: "intersectingIndex"
    }
  }, [_c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-content"
    }
  }, [_vm._v("상품정보")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-review"
    }
  }, [_vm._v("기대평/리뷰")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-inquiry"
    }
  }, [_vm._v("상품문의")])], 1), _c('v-tab', [_c('v-btn', {
    attrs: {
      "x-large": "",
      "text": "",
      "block": "",
      "ripple": false,
      "href": "#product-delivery"
    }
  }, [_vm._v("교환/환불/배송")])], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "mt-n60px pt-60px",
    attrs: {
      "id": "product-content"
    }
  }), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onDetails,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onDetails, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "mb-10px"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": "/images/products/gift-guide.jpg"
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm$product8 = _vm.product) === null || _vm$product8 === void 0 ? void 0 : _vm$product8.content)
    }
  })], 1)]), _c('div', {
    staticClass: "pt-60px",
    attrs: {
      "id": "product-review"
    }
  }), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onExpectReview,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onExpectReview, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "mb-10px"
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("기대평")])]), _c('expectation-list', {
    attrs: {
      "product": _vm.product
    }
  }), _c('div', {
    staticClass: "pt-60px"
  }), _c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("리뷰")])]), _c('review-list', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _c('div', {
    staticClass: "pt-60px",
    attrs: {
      "id": "product-inquiry"
    }
  }), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onInquiry,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onInquiry, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "mb-10px"
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상품문의")])]), _c('inquiry-list', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _c('div', {
    staticClass: "pt-60px",
    attrs: {
      "id": "product-delivery"
    }
  }), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onExchange,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onExchange, options: { threshold: [0, 1.0] } }"
    }]
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("교환/반품/품절안내")])]), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("반품/교환방법")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_c('router-link', {
    staticClass: "primery--text",
    attrs: {
      "to": "/mypage/shop/purchases"
    }
  }, [_vm._v("마이페이지 > 주문배송조회 > 반품/교환신청 , "), _c('br'), _vm._v("고객센터 > 1:1문의를 통해 반품 > 교환신청 또는 고객센터 (1800-9510)")])], 1), _c('p', [_vm._v("※ 오픈마켓, 해외배송주문, 기프트 주문시 "), _c('router-link', {
    attrs: {
      "to": "/center/questions"
    }
  }, [_vm._v("[1:1문의]")]), _vm._v(" 또는 고객센터 (1800-9510)")], 1)])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("반품/교환가능 기간")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("변심반품의 경우 수령 후 7일 이내, 상품의 결함 및 계약내용과 다를 경우 문제점 발견 후 30일 이내")])])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("반품/교환비용")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("변심 혹은 구매착오로 인한 반품/교환은 반송료 고객 부담")])])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("반품/교환 불가 사유")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("소비자의 책임 있는 사유로 상품 등이 손실 또는 훼손된 경우 (단지 확인을 위한 포장 훼손은 제외)")]), _c('p', [_vm._v("소비자의 사용, 포장 개봉에 의해 상품 등의 가치가 현저히 감소한 경우"), _c('br'), _vm._v("예) 화장품, 식품, 가전제품(악세서리 포함) 등")]), _c('p', [_vm._v("복제가 가능한 상품 등의 포장을 훼손한 경우"), _c('br'), _vm._v("예) 음반/DVD/비디오, 소프트웨어, 만화책, 잡지, 영상 화보집")]), _c('p', [_vm._v("소비자의 요청에 따라 개별적으로 주문 제작되는 상품의 경우 ((1)해외주문도서)"), _c('br'), _vm._v("(1)해외주문도서 : 이용자의 요청에 의한 개인주문상품으로 단순변심 및 착오로 인한 취소/교환/반품 시 ‘해외주문 반품/취소 수수료’고객 부담 (해외주문 반품/취소 수수료 : ①양서-판매정가의 12%, ②일서-판매정가의 7%를 적용)")]), _c('p', [_vm._v("디지털 컨텐츠인 eBook, 오디오북 등을 1회 이상 다운로드를 받았을 경우")]), _c('p', [_vm._v("시간의 경과에 의해 재판매가 곤란한 정도로 가치가 현저히 감소한 경우")]), _c('p', [_vm._v("전자상거래 등에서의 소비자보호에 관한 법률이 정하는 소비자 청약철회 제한 내용에 해당되는 경우")])])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("상품 품절")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("공급사(출판사) 재고 사정에 의해 품절/지연될 수 있으며, 품절 시 관련 사항에 대해서는 이메일과 문자로 안내드리겠습니다.")])])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("소비자 피해보상 환불지연에 따른 배상")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("상품의 불량에 의한 교환, A/S, 환불, 품질보증 및 피해보상 등에 관한 사항은 소비자분쟁해결 기준 (공정거래위원회 고시)에 준하여 처리됨")]), _c('p', [_vm._v("대금 환불 및 환불지연에 따른 배상금 지급 조건, 절차 등은 전자상거래 등에서의 소비자 보호에 관한 법률에 따라 처리함")])])])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("청약 철회 방침")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("상품 발송 후 환불 신청 시 반품확인 여부를 확인 후 3~5영업일 이내 결제금액을 환불해 드립니다.")]), _c('p', [_vm._v("신용카드로 결제하신 경우 신용카드 승인을 취소하여 결제대금이 청구되지 않게 합니다."), _c('br'), _vm._v("(단, 신용카드 결제일자에 맞추어 대금이 청구 될 수 있으며, 이경우 익월 신용카드 대금 청구 시 카드사에서 환급 처리 됩니다.)​")])])])])])])], 1)])], 1), _c('login-dialog', {
    ref: "loginDialog"
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }